import React from 'react';
import _ from 'underscore';
import { Checkbox } from './checkbox';
import { ICheckboxGroupProps, ICheckboxGroupState } from './types';

export class CheckboxGroup<TItem = string> extends React.PureComponent<ICheckboxGroupProps<TItem>, ICheckboxGroupState> {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static defaultProps: Partial<ICheckboxGroupProps> = {
    checked: [],
    getItemId: (item, index) => String(index),
    getItemValue: null,
    name: null,
    renderItem: () => null,
    disabled: false,
  };

  static getDerivedStateFromProps<TItem>(
    nextProps: ICheckboxGroupProps<TItem>,
    prevState: ICheckboxGroupState
  ): ICheckboxGroupState {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('checkbox-group-'),
    };
  }

  constructor(props: ICheckboxGroupProps<TItem>) {
    super(props);
    this.state = {} as ICheckboxGroupState;
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <>
        {this.props.items.map((item: TItem, index: number) => {
          const id = this.props.getItemId(item, index);
          const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
            const checked = event.target.checked
              ? [...this.props.checked, item]
              : _.without(this.props.checked, item);

            this.props.onChange(checked);
          };
          return (
            <Checkbox
              key={id}
              id={`${this.state.name}-${id}`}
              checked={_.contains(this.props.checked, item)}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue!(item, index)}
              disabled={this.props.disabled}
            >
              {this.props.renderItem(item, index)}
            </Checkbox>
          );
        })}
      </>
    );
  }
}
